import React from 'react';
import { LinkContainer } from 'react-router-bootstrap';

const Link = props => (
  <LinkContainer to={props.href} exact>
    <a>{props.children}</a>
  </LinkContainer>
);

export default Link;



// WEBPACK FOOTER //
// ./src/components/Link.js